/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useEffect, useState } from 'react';

export default function useScrollLinkItem(to) {
  const [activeLink, setActiveLink] = useState('');
  const [active, setActive] = useState(false);

  // function to invoke in react scroll library and detect active link with onSetActive prop
  const handleSetActive = () => {
    // if there is an active link update it in activeLink state
    if (to) {
      setActiveLink({ activeLink: to });
    }
  };

  useEffect(() => {
    // if the link active set the state active to true and use this state to render the wanted circularProgress
    if (activeLink) {
      setActive(state => !state);
    }
  }, [activeLink]);

  return {
    handleSetActive,
    active,
  };
}
